export default function Impressum() {
    return (
        <div data-testid="page-impressum" className="pt-16 md:pt-24 pb-24">
            <div className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-16">
                <p className="overline mb-6">Rechtliches</p>
                <h1 className="font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95] font-medium text-ink mb-12">
                    Impressum
                </h1>

                <div className="font-body text-[15px] leading-relaxed text-ink space-y-8">
                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Angaben gemäß § 5 TMG</h2>
                        <p>
                            Rapid Key &amp; Go GmbH · Mein Schuster<br/>
                            Schuh- und Schlüsseldienst<br/>
                            Weichser Weg 5<br/>
                            93059 Regensburg<br/>
                            Donau-Einkaufszentrum (DEZ)
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Kontakt</h2>
                        <p>
                            Telefon: <a href="tel:+499414610027" className="text-brand hover:underline">+49 941 4610027</a><br/>
                            E-Mail: <a href="mailto:agisschluesseldienst@gmail.com" className="text-brand hover:underline">agisschluesseldienst@gmail.com</a>
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Identifikation</h2>
                        <p>
                            Amtsgericht Mannheim HRB 754223
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                        <p>
                            Furkan Agis / Rapid Key &amp; Go GmbH<br/>
                            Wallstadter Str. 10<br/>
                            68259 Mannheim
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Streitschlichtung</h2>
                        <p>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:&nbsp;
                            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
                                https://ec.europa.eu/consumers/odr
                            </a>
                            . Unsere E-Mail-Adresse finden Sie oben im Impressum.
                        </p>
                        <p className="mt-3">
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
                            vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Haftung für Inhalte</h2>
                        <p>
                            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
                            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
                            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
                            übermittelte oder gespeicherte fremde Informationen zu überwachen
                            oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                            hinweisen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl font-bold mb-3">Urheberrecht</h2>
                        <p>
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                            diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge
                            Dritter sind als solche gekennzeichnet. Die Vervielfältigung,
                            Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
                            des jeweiligen Autors bzw. Erstellers.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}
